'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _EditOwnerRealtor = require('./EditOwnerRealtor.scss');var styles = _interopRequireWildcard(_EditOwnerRealtor);
var _constants = require('../../constants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
var EditOwnerRealtor = function (_Component) {_inherits(EditOwnerRealtor, _Component);function EditOwnerRealtor() {var _temp, _this, _ret;_classCallCheck(this, EditOwnerRealtor);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.










    renderField = function (_ref) {var input = _ref.input,_ref$meta = _ref.meta,touched = _ref$meta.touched,error = _ref$meta.error,active = _ref$meta.active,props = _objectWithoutProperties(_ref, ['input', 'meta']);return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.content, { 'has-error': error && !active && touched }) },
          _react2.default.createElement('div', { className: styles.fieldInput },
            _react2.default.createElement('input', _extends({},
            input, {
              placeholder: _this.props.translate('editOwner', 'realtorName') + ' *',
              className: (0, _classnames2.default)('form-control', { 'has-error': error && !active && touched, touched: touched }) }))),


          _react2.default.createElement('div', { className: styles.image },
            _this.props.renderComponentImages(input.name.replace('name', 'image'))),

          touched &&
          error && _react2.default.createElement('span', { className: styles.error }, _this.props.translate('errorFieldMessages', 'required'))));}, _this.



    renderFieldWithLabel = function (name, placeholder, type, req, label) {return (
        _react2.default.createElement(_reduxForm.Field, {
          name: name,
          type: type || name,
          placeholder: placeholder || name,
          label: label || placeholder,
          required: req,
          component: _this.renderField }));}, _this.



    renderDeleteBtn = function (index, fields) {
      var deleteItem = function deleteItem() {
        fields.remove(index);

        if (_this.props.initialValues && _this.props.initialValues.realtors[index]) {
          _this.props.initialValues.realtors.splice(index, 1);
        }
      };

      return (index > 0 || index >= 1) &&
      _react2.default.createElement('div', { className: styles.deleteCurrentRealtor, onClick: deleteItem },
        _react2.default.createElement('i', { className: 'icon-close' }));


    }, _this.

    renderRealtor = function (realtor, index, fields) {
      var id = fields.get(index).id;
      var title = _this.props.companyType === _constants.PROFESSIONALS_TYPES.AGENCY ? 'realtor' : 'crewMember';

      return (
        _react2.default.createElement('div', { className: styles.realtor, key: id },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: styles.title },
              _this.props.translate('editOwner', title), ' ', index + 1,
              _this.renderDeleteBtn(index, fields)),

            _this.renderFieldWithLabel(
            realtor + '.name',
            _this.props.translate('editOwner', 'hebrew') + ' *',
            'text',
            true, '' +
            _this.props.translate('editOwner', 'realtorName'),
            index,
            fields))));




    }, _this.

    renderRealtors = function (_ref2) {var fields = _ref2.fields;
      var handleAddRealtor = function handleAddRealtor(evt) {
        evt.preventDefault();
        fields.push({ id: Date.now().toString(32) });
      };
      var title = _this.props.companyType === _constants.PROFESSIONALS_TYPES.AGENCY ? 'addNewPerson' : 'addNewCrewMember';

      return (
        _react2.default.createElement('div', null,
          fields.map(function (realtor, index, array) {return _this.renderRealtor(realtor, index, array);}),
          _react2.default.createElement('div', { className: styles.addBtnWrapper },
            _react2.default.createElement('button', { className: styles.addBtn, onClick: handleAddRealtor }, '+ ',
              _this.props.translate('editOwner', title)))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}EditOwnerRealtor.prototype.componentDidMount = function componentDidMount() {this.props.push('realtors', { id: Date.now().toString(32) });};EditOwnerRealtor.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {var isLocaleChanged = nextProps.locale !== this.props.locale;var isCompanyTypeChanged = nextProps.companyType !== this.props.companyType;return isLocaleChanged || isCompanyTypeChanged;};EditOwnerRealtor.prototype.

  render = function render() {
    return _react2.default.createElement(_reduxForm.FieldArray, { name: 'realtors', component: this.renderRealtors });
  };return EditOwnerRealtor;}(_react.Component);


EditOwnerRealtor.propTypes = {
  push: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  renderComponentImages: _propTypes2.default.func,
  isEditPage: _propTypes2.default.bool,
  isSingleBranch: _propTypes2.default.bool,
  companyType: _propTypes2.default.string,
  initialValues: _propTypes2.default.object };exports.default =


EditOwnerRealtor;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditOwnerRealtor/EditOwnerRealtor.js
// module id = 2661
// module chunks = 0